import { useCallback } from "react";

// Hook for managing task tags
function useTaskTags(task, onUpdateTask) {
  const handleTagToggle = useCallback(
    (tag) => {
      const newTags = (task.tags || []).includes(tag)
        ? (task.tags || []).filter((t) => t !== tag)
        : [...(task.tags || []), tag];
      onUpdateTask(task.id, { tags: newTags });
    },
    [task.id, task.tags, onUpdateTask]
  );

  return { handleTagToggle };
}

export default useTaskTags;
